var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.125,
    height: 44.125,
    viewBox: "0 0 44.125 44.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M86.045,328.783A22.082,22.082,0,1,1,63.982,306.72a22.063,22.063,0,0,1,22.063,22.063Zm0,0",
    transform: "translate(-41.92 -306.72)",
    fill: "#d63243"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M58.768,307.96v42.885a22.069,22.069,0,0,1,0-42.885Zm0,0",
    transform: "translate(-41.92 -307.34)",
    fill: "#5fa428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M75.623,341.517a9.339,9.339,0,1,1-9.338-9.339,9.339,9.339,0,0,1,9.338,9.339Zm0,0",
    transform: "translate(-49.436 -319.454)",
    fill: "#ffc716"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M70.746,352.832a4.882,4.882,0,0,1-4.883-4.882v-6.462h9.765v6.462a4.882,4.882,0,0,1-4.882,4.882Zm0,0",
    transform: "translate(-53.896 -324.111)",
    fill: "#fef2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M70.951,350.817h-1a.3.3,0,0,0-.294.294v.758a.8.8,0,0,0,1.59,0v-.758a.294.294,0,0,0-.294-.294Zm0,0",
    transform: "translate(-55.793 -328.777)",
    fill: "#2564ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M75.336,350.817h-1a.294.294,0,0,0-.294.294v.758a.8.8,0,0,0,1.59,0v-.758a.3.3,0,0,0-.295-.294Zm0,0",
    transform: "translate(-57.987 -328.777)",
    fill: "#2564ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M75.336,345.748h-1a.294.294,0,0,0-.294.294v.758a.8.8,0,1,0,1.59,0v-.758a.3.3,0,0,0-.295-.294Zm0,0",
    transform: "translate(-57.987 -326.242)",
    fill: "#2564ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M75.336,355.886h-1a.294.294,0,0,0-.294.294v.758a.8.8,0,0,0,1.59,0v-.758a.3.3,0,0,0-.295-.294Zm0,0",
    transform: "translate(-57.987 -331.313)",
    fill: "#2564ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M79.722,350.817h-1a.3.3,0,0,0-.294.294v.758a.8.8,0,0,0,1.59,0v-.758a.294.294,0,0,0-.294-.294Zm0,0",
    transform: "translate(-60.18 -328.777)",
    fill: "#2564ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M74.95,340.134H65.185a.677.677,0,0,0-.677.677v6.462a5.559,5.559,0,0,0,11.119,0v-6.462a.677.677,0,0,0-.677-.677Zm-.677,7.139a4.206,4.206,0,0,1-8.411,0v-5.785h8.411Zm0,0",
    transform: "translate(-53.219 -323.434)",
    fill: "#da4d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M46.8,329.4a22.059,22.059,0,0,0,11.966,19.62v1.822a22.069,22.069,0,0,1,0-42.885v1.822A22.059,22.059,0,0,0,46.8,329.4Zm0,0",
    transform: "translate(-41.92 -307.34)",
    fill: "#5fa428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M46.8,329.4a22.059,22.059,0,0,0,11.966,19.62v1.822a22.069,22.069,0,0,1,0-42.885v1.822A22.059,22.059,0,0,0,46.8,329.4Zm0,0",
    transform: "translate(-41.92 -307.34)",
    fill: "#599329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M75.63,390.119v1.822a22.267,22.267,0,0,0,7.657.486,21.872,21.872,0,0,1-7.657-2.308Zm0,0",
    transform: "translate(-58.782 -348.436)",
    fill: "#cf182d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M83.287,306.854a22.276,22.276,0,0,0-7.657.486v1.822a21.871,21.871,0,0,1,7.657-2.308Zm0,0",
    transform: "translate(-58.782 -306.72)",
    fill: "#cf182d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.98bc5cb547ac086d8aa7af6fc546be75.svg";
export { ForwardRef as ReactComponent };